import { ProvinceType } from '@spaq/utils/shared-constants';
import { fromJS } from 'immutable';
import * as moment from 'moment-timezone';

export enum Sex {
	Female = 'Femme',
	Male = 'Homme',
	Unknown = 'Inconnu',
	xx = ''
}

export enum Language {
	French = 'Français',
	English = 'Anglais'
}

export enum DocumentType {
	SpaqCard = '',
	Transponder = '',
	PermantlyLabel = '',
	MonthlyLabel = '',
	CapitalCard = '',
	OwnerCard = '',
	SpaqBikeCard = ''
}

export enum DocumentState {
	InCirculation = '',
	Available = '',
	Lost = '',
	Broken = '',
	Nap = ''
}

export interface AccesDocumentInfo {
	documentNo?: string;
	documentState?: DocumentState;
	documentType?: DocumentType;
}

export interface SubscriptionInfo {
	custom: any;
	spaq: SubscriptionSpaqInfo;
}

export interface PaymentMethodInfo {
	creditCardDataKey: string;
	effectiveDate: string;
	endDate: string;
	financialInstitutionId: number;
	folioNo: string;
	method: 'Cash' | 'PreAuthorized' | 'Credit' | 'DAS' | 'DeductionAtSource' | 'NotDefined' | 'CreditLumpSum';
	transitNo: string;
}

export interface SubscriptionSpaqInfo {
	accesDocuments?: AccesDocumentInfo[];
	accessOnHoldReason: string;
	addressLine1: string;
	addressLine2: string;
	appartmentNo: string;
	balance: number;
	cellPhone: string;
	city: string;
	contractNo: number;
	dynamicFieldJsonData: string;
	email: string;
	firstName: string;
	homePhone: string;
	homePhoneExtension: string;
	isAccessOnHold: boolean;
	language: Language;
	lastName: string;
	paymentMethod: PaymentMethodInfo | null;
	postalCode: string;
	province: ProvinceType;
	serviceCenter: number;
	sex: Sex;
	workPhone: string;
	workPhoneExtension: string;
}

export class SubscriptionModel {
	get rawData(): SubscriptionSpaqInfo {
		return this.data;
	}

	private data: SubscriptionSpaqInfo = {
		accesDocuments: [],
		accessOnHoldReason: '',
		addressLine1: '',
		addressLine2: '',
		appartmentNo: '',
		balance: 0,
		cellPhone: '',
		city: '',
		contractNo: 0,
		dynamicFieldJsonData: '',
		email: '',
		firstName: '',
		homePhone: '',
		homePhoneExtension: '',
		isAccessOnHold: false,
		language: Language.French,
		lastName: '',
		paymentMethod: null,
		postalCode: '',
		province: 'QC',
		serviceCenter: 0,
		sex: Sex.Male,
		workPhone: '',
		workPhoneExtension: ''
	};

	constructor(data?: SubscriptionSpaqInfo) {
		if (data) {
			Object.keys(data).forEach(k => {
				if (this.data[k] !== undefined) {
					this.data[k] = data[k];
				}
			});
		}
		if (!this.data['paymentMethod']) {
			this.data['paymentMethod'] = {
				method: 'Cash',
				effectiveDate: null,
				endDate: null,
				transitNo: null,
				folioNo: null,
				creditCardDataKey: null,
				financialInstitutionId: null
			};
		}
	}

	getData() {
		return fromJS(this.data);
	}

	getRequired() {
		return ['firstName', 'lastName', 'addressLine1', 'city', 'postalCode', 'language', 'province', 'sex'];
	}

	set(name, value) {
		const newData = { ...this.data };

		newData[name] = value;

		this.data = newData;
	}
}

export class SubscriptionServiceModel {
	get cancellationDateRequestFormated() {
		return moment(this.rawData.cancellationDateRequest).tz('America/Montreal').format('LL');
	}

	get rawData(): any {
		return this._data;
	}

	private _data: any = {
		effectiveDate: null,
		endDate: null,
		isPaidByGroup: null,
		serviceDescription: null,
		subscriptionService: null,
		serviceId: null,
		isApproved: null,
		isCancellationRequest: false,
		cancellationDateRequest: null
	};

	constructor(data?: any) {
		if (data) {
			Object.keys(data).forEach(k => {
				if (this._data[k] !== undefined) {
					this._data[k] = data[k];
				}
			});
		}
	}

	set(name, value) {
		const newData = { ...this._data };

		newData[name] = value;

		this._data = newData;
	}
}
